import {css} from 'lit';
export const styles = css`:host {
  display: block;
  background: white;
  border: 1px solid #ccc;
}

:host([focus-within]) {
  border: 1px solid red;
}

:host(:focus-within) {
  border: 1px solid red;
}

::slotted(input) {
  border: none;
  outline: none;
}
`;
export default styles;
